// src/components/BarChartMonth.js

import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import Chart from 'chart.js/auto';

const BarChartMonth = () => {
    
    const [dataValues, setDataValues] = useState([190, 170, 220, 180, 200]); // Valores de consumo

    const [labels, setLabels] = useState([]);

    useEffect(() => {
        // Obtener la fecha actual
        const currentDate = new Date();
        const last5Months = [];

        for (let i = 0; i < 5; i++) {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // Los meses en JavaScript comienzan desde 0
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
        last5Months.unshift(`${formattedMonth}-${year}`);
        currentDate.setMonth(currentDate.getMonth() - 1);
        }

        setLabels(last5Months);
    }, []);

    const data = {
        labels: labels,
        datasets: [
        {
            label: 'Wh',
            data: dataValues,
            backgroundColor: ['#FF7705', '#FF7705', '#FF7705', '#FF7705', '#FF7705'],
        },
        ],
    };

  
    const options = { 
        scales: {
            y: {
                beginAtZero: true,
                title: {
                    display: true,
                    text: 'Wh',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Mes',
                    font: {
                        size: 16, // Tamaño de fuente más grande
                        weight: 'bold', // Texto en negrita
                    },
                },
                ticks: {
                    font: {
                      size: 14, // Tamaño de fuente más grande
                      weight: 'bold', // Texto en negrita
                    },
                },
            },
        },
        plugins: {
            title: {
              display: false, // Establece display en false para ocultar el título
            },
            legend: {
                display: false, // Oculta la leyenda
            }, 
        },
    };
  
    return (
        <Bar data={data} options={options} width={'100%'} height={'100%'}/>
    );
  };
  
  export default BarChartMonth;